"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgTokensEeService", {
    enumerable: true,
    get: function() {
        return OrgTokensEeService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OrgTokensEeService = class OrgTokensEeService {
    async apiTokenListEE(param) {
        let fk_user_id = param.user.id;
        // if super admin get all tokens
        if ((0, _nocodbsdk.extractRolesObj)(param.user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) {
            fk_user_id = undefined;
        }
        return new _PagedResponse.PagedResponseImpl(await _models.ApiToken.listWithCreatedBy(_extends({}, param.query, {
            fk_user_id
        })), _extends({}, param.query || {}, {
            count: await _models.ApiToken.count({})
        }));
    }
};
OrgTokensEeService = _ts_decorate([
    (0, _common.Injectable)()
], OrgTokensEeService);
